import { render, staticRenderFns } from "./BaseTradingChips.vue?vue&type=template&id=40dc5906&scoped=true"
import script from "./BaseTradingChips.vue?vue&type=script&lang=js"
export * from "./BaseTradingChips.vue?vue&type=script&lang=js"
import style0 from "./BaseTradingChips.vue?vue&type=style&index=0&id=40dc5906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc5906",
  null
  
)

export default component.exports